(function () {
  const wrapper = document.querySelector('.countdown-wrapper[data-countdown-total-seconds]');
  if (!wrapper) return;

  let total = parseInt(wrapper.dataset.countdownTotalSeconds || '86400', 10);
  if (!Number.isFinite(total) || total < 0) total = 0;

  const elHours = wrapper.querySelector('[data-countdown-unit="hours"]');
  const elMins = wrapper.querySelector('[data-countdown-unit="mins"]');
  const elSecs = wrapper.querySelector('[data-countdown-unit="secs"]');

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function tick() {
    const h = Math.floor(total / 3600);
    const m = Math.floor((total % 3600) / 60);
    const s = total % 60;
    if (elHours) elHours.textContent = pad(h);
    if (elMins) elMins.textContent = pad(m);
    if (elSecs) elSecs.textContent = pad(s);
    if (total <= 0) return;
    total--;
  }

  tick();
  setInterval(tick, 1000);
})();
